module.exports = __webpack_public_path__ + "img/svg/ellipse-filled.c89d31a27ed0de207b9a506f3589ea7e.svg";